import React from 'react';
import { DATA_RATING } from '../../../common/constants/data-attributes';
import { RATING_DISPLAY } from '../../../common/constants/data-hooks';
import { StarIcon } from './star-icon';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { classes, st } from './one-star-display.st.css';
export const OneStarDisplay = ({ rating = 0 }) => {
    const t = useTranslate();
    return (React.createElement("div", { className: st(classes.root, { withRating: !!rating }), "data-hook": RATING_DISPLAY, [DATA_RATING]: rating },
        React.createElement("span", { title: t('ratings-display.rating-aria-label', { rating }), role: "region" }),
        React.createElement("div", { "aria-hidden": "true", className: classes.innerContainer },
            React.createElement(StarIcon, null))));
};
//# sourceMappingURL=one-start-display.js.map